import Parcel from '../../../api/Parcel';
import ResponseResult from '../../../api/ResponseResult';
import ResponseError from '../../../api/ResponseError';

export default class ProductWatchPrototypeListParcel extends Parcel {

    constructor(filters, orders, page, pageSize) {
        super();

        const {
            keyword = '',
            extraIds = [],
            brandIds = [],
            conditionLevels = [],
            productAttributeIdLists = [],
            priceRange = [null, null],
            publishedOnly = true
        } = filters;

        this.setEndpoint('/api/product-watch-prototype/list');

        this.setRequestMethod('GET');

        this.setQueryParam('keyword', JSON.stringify(keyword));

        this.setQueryParam('extraIds', extraIds);

        this.setQueryParam('brandIds', brandIds);

        this.setQueryParam('conditionLevels', conditionLevels);

        this.setQueryParam('productAttributeIdLists', productAttributeIdLists);

        this.setQueryParam('priceRange', priceRange);

        this.setQueryParam('publishedOnly', publishedOnly);

        this.setQueryParam('orders', orders);

        this.setQueryParam('limit', pageSize);

        this.setQueryParam('offset', page * pageSize);
    }

    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }

    parseResponseResult(rawResult) {
        if (rawResult.error) {
            return new ResponseResult(null, new ResponseError(rawResult.error.message));
        }

        return new ResponseResult(rawResult.data, null);
    }
}
